<template>
  <div class="user-main" :style="{minHeight:(screenHeight-85)+'px'}">
    <section class="user-section">
      <div class="user__company">
        <h1 class="user__company-name">

          <span class="user__company-name--eng">{{companyInfo.shortEngName}}</span>
          <span class="user__company-name--chn">{{companyInfo.shortChnName}}</span>
        </h1>
        <div class="user__company-info" v-html="companyInfo.aboutCompany"></div>
      </div>
      <router-view></router-view>
    </section>
  </div>
</template>
<script>

  import {mapGetters} from 'vuex';
  import * as types from '../vuex/types';

  export default {
    data () {
      return {
        screenHeight: document.body.clientHeight
      };
    },
    computed: {
      ...mapGetters({
        companyInfo: types.GET_COMPANY_INFO
      })
    }
  };
</script>
<style lang="scss">
  .user-main {
    overflow: hidden; // 不加会导致IE兼容问题
    width: 100%;

    background: url("../../static/images/bgt.png") no-repeat;
    background-size: cover;
  }

  .user-section {
    /*@include absolute-center;*/
    margin:80px auto;
    @include clear;
    width: $containerWidth;
  }

  .user__company {
    float: left;
    width: 526px;

    & > *{
      font-family: 'FZLanTingHei_GBK';
      color:#fff;
      text-indent:35px;
      line-height: 36px;
	  text-indent:35px;
      line-height: 36px;
    }
  }

  .user__company-name {
    margin-bottom: 50px;
  }

  .user__company-name--eng {
    font-family: "Anders", "Arial";
    font-size: 36px;
    color: $white;
  }

  .user__company-name--chn {
    font-size: 28px;
    color: $orange;
    font-family: "FANGZHENGCUTANHEIJIANTI941", "Arial";
  }

  .user__company-info {
    & > div {
      padding: 0;
      color:#fff;
      font-size: 14px;
      line-height: 37px;
      font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
    }

    &:after {
      content: '';
      display: block;
      margin-top: 30px;
      width: 60px;
      height: 2px;
      background: $white;
    }
  }
</style>



// WEBPACK FOOTER //
// User.vue?e852dc6a